import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import { HighlightService } from "./highlight.service";
import { from } from "rxjs";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "highlight",
  templateUrl: "./highlight.component.html",
  styleUrls: ["./highlight.component.scss"]
})
export class HighlightComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  dataLoading = false;
  mockData = {
    "data": [
      {
        "bucket": "month",
        "percentage": 100,
        "comparison": 100
      }
    ]
  };

  @Input() TITLE = "";
  @Input() API = "";
  @Input() TEXT = "";
  @Input() URLPARAM = "";

  __data: any;
  panel: any = {};

  constructor(
    private HighLight: HighlightService,
    private ChangeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    let url = this.API;
  
    this.HighLight.GetPercentValue(url, this.URLPARAM).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.__data = res;
      this.__data = res['data'] && res['data'].length && res['data'][0]['comparison'] ? res : '';
      this.dataLoading = true;
    }, error => {
      this.dataLoading = true;
    });
  }

  shortenedText(text) {
    if (text.indexOf("Yesterday") > -1 && text.length >= 14) {
      return `YEST ${text.substr(12)}`;
    }
    if (text.indexOf("Yesterday") > -1) {
      return `YEST ${text.substr(10)}`;
    }

    if (text.indexOf("Month") > -1) {
      return `MTD ${text.substr(14)}`;
    }
    if (text.indexOf("Quarter") > -1) {
      return `QTD ${text.substr(16)}`;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
